import React, { useMemo } from "react";
import { randomSelection } from "../helpers";
import { Skeleton, Tooltip } from "@mui/material";
import { createPortal } from "react-dom";



const GetStartedPrompts = ({ isStarted, prompts, loading, followUpPrompts, ticker, onSendMessage, fullscreen = false }) => {
  const possiblePrompts = [
    { title: "Summarize", description: `the latest SEC filing for ${ticker}` },
    { title: "When is", description: `${ticker}'s upcoming earnings?` },
    { title: "Recent news", description: `related to ${ticker}` },
    { title: "Analysts' outlook", description: `on ${ticker}` },
    { title: "Do a technical analysis", description: `on ${ticker}` },
    { title: "Give me the earning date", description: `for ${ticker}` },
    { title: "Give me the top option recommendation", description: `for ${ticker}` },
    { title: "What are the interesting news", description: `happening for ${ticker}` },
    { title: "Do a technical analysis", description: `for ${ticker}` },
    { title: "Summarize the latest SEC filing", description: `for ${ticker}` },
    { title: "How did", description: `${ticker} perform compared to SPY` }
  ];

  const suggestionPrompts = useMemo(() => {
    return !!followUpPrompts?.length ? followUpPrompts : randomSelection(ticker ? possiblePrompts : prompts, 4) 
  }, [ticker, followUpPrompts, prompts]);

  // Component to handle tooltip
  const PromptItem = ({ prompt, index, onClick }) => {
    const fullText = `${prompt.title} ${prompt.description}`;

    return (
      <Tooltip 
        title={fullText}
        placement="top"
        arrow
        disablePortal={false}
        PopperProps={{
          container: document.body,
          style: { 
            zIndex: 2147483647, // Maximum safe z-index value
            position: 'fixed'
          },
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -25], // Negative value brings it closer, adjust as needed
              },
            },
          ],
        }}
        componentsProps={{
          tooltip: {
            sx: {
              bgcolor: 'rgba(0, 0, 0, 0.9)',
              color: 'white',
              fontSize: '12px',
              maxWidth: '300px',
              '& .MuiTooltip-arrow': {
                color: 'rgba(0, 0, 0, 0.9)',
              },
            }
          }
        }}
      >
        <div 
          onClick={onClick} 
          className="tradegpt-widget__content__get_started__item"
          style={{ cursor: 'pointer' }}
        >
          <div className="tradegpt-widget__content__get_started__item__title">
            {prompt.title}
          </div>
          <div className="tradegpt-widget__content__get_started__item__description">
            {prompt.description}
          </div>
        </div>
      </Tooltip>
    );
  };

  return (
    <div className="tradegpt-widget__content__get_started">
      <div className="tradegpt-widget__content__get_started__title">
        {isStarted ? "Get Started with these Prompts" : "Related Prompts"}
      </div>
      <div className={`${fullscreen === false ? isStarted ? 'tradegpt-widget__content__get_started__items-vertical' : 'tradegpt-widget__content__get_started__items' : 'tradegpt-widget__content__get_started__items full-screen-view'}`}>
        {
          suggestionPrompts?.map((prompt, index) => loading && !ticker ? (
            <Skeleton key={index} width={336} height={50} sx={{ borderRadius: '16px' }} />
          ) : (
            <PromptItem 
              key={index}
              prompt={prompt}
              index={index}
              onClick={() => onSendMessage(prompt.title + " " + prompt.description, true)}
            />
          ))
        }
      </div>
    </div>
  );
}

export default GetStartedPrompts;
